import React from "react";
import { UISref } from "@uirouter/react";
import styled from "styled-components";

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Anchor = styled.a`
    color: #6c6c6c !important;
    cursor: pointer;
`;

const CurrentLocationAnchor = styled(Anchor)`
    text-decoration: none !important;
`;

const StyledSpan = styled.span`
    text-decoration: underline;
`;

const UseMyCurrentLocation = ({ showingAll, jumpToCurrentLocation }) => (
    <Wrapper>
        <CurrentLocationAnchor id="use-current-location" onClick={jumpToCurrentLocation}>
            <StyledSpan>Use My Current Location</StyledSpan>
            &nbsp;
            <i className="icon-sun" />
        </CurrentLocationAnchor>

        {!showingAll && (
            <UISref to="home">
                <Anchor>Show All</Anchor>
            </UISref>
        )}
    </Wrapper>
);

export default UseMyCurrentLocation;



// WEBPACK FOOTER //
// ./components/index/UseMyCurrentLocation.jsx